import { useEffect } from 'react'
import { useTenantBranding } from './useTenantBranding'

/**
 * ページタイトル（ブラウザタブの title）を設定する。
 * マウント中だけ書き換え、アンマウント時に元のタイトルに戻す。
 * サービス名はテナント別 (sooki → Rabbit Live, kanamoto → kanaReco, その他 → JIZAIPAD) に切り替わる。
 */
export function usePageTitle (title: string): void {
  const { serviceName } = useTenantBranding()
  useEffect(() => {
    const previous = document.title
    document.title = title === '' ? serviceName : `${title} | ${serviceName}`
    return () => {
      document.title = previous
    }
  }, [title, serviceName])
}
